import { createContext, useContext, useEffect } from 'react'

const OrgScopeContext = createContext<string | null>(null)

let currentOrgId: string | null = null

export function AdminOrgScopeProvider({
  organizationId,
  children,
}: {
  organizationId: string | null
  children: React.ReactNode
}) {
  // Set during render on purpose: the generated adapters read this synchronously
  // when they build a request, and a query that fires before the effect below
  // would otherwise go out unscoped and return every tenant's rows.
  // eslint-disable-next-line react-hooks/set-state-in-render
  currentOrgId = organizationId

  useEffect(() => {
    currentOrgId = organizationId
    return () => {
      currentOrgId = null
    }
  }, [organizationId])
  return <OrgScopeContext.Provider value={organizationId}>{children}</OrgScopeContext.Provider>
}

export function useAdminOrgScope(): string | null {
  return useContext(OrgScopeContext)
}

export function getAdminOrgScope(): string | null {
  if (currentOrgId !== null) return currentOrgId
  try {
    return localStorage.getItem('thecargo.admin.org-scope')
  } catch {
    return null
  }
}
